import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteConditionsMutationProps = {
	ids: number[]
	onSettled: () => void
}

export const useDeleteConditionsMutation = ({
	ids,
	onSettled
}: UseDeleteConditionsMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: deleteConditionsMutation } = useMutation({
		mutationFn: () => axiosPrivate.post(apiRoutes.conditionsDelete, { ids }),
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Conditions deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.conditions.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteConditionsMutation
	}
}
